const CurvedLine1 = () => {
  return (
    <svg viewBox="0 0 1440 1260" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.05"
        d="M-91.1666 62.1077C36.7732 117.316 260.545 338.405 497.139 64.9374C668.152 -132.728 934.714 38.2246 1112.95 66.784C1268.85 91.7661 1319.64 5.14406 1176.5 -85.484C1041.32 -171.076 885.607 55.8726 1226.81 227.548C1623.88 427.334 1512.08 718.841 1386.73 836.109C1261.39 953.377 1418.97 1196.32 1677.36 1254.87C1884.07 1301.71 1891.84 1488.69 1869.89 1576.33"
        stroke="#29061C"
        strokeWidth="4"
      />
    </svg>
  );
};

export default CurvedLine1;
